import 'codemirror/mode/css/css';

export const id = 'css';
export const displayName = 'CSS';
export const mimeTypes = ['text/css'];



/** WEBPACK FOOTER **
 ** ./src/parsers/css/index.js
 **/